import React from "react";
import { CollapseCard } from "@totalsoft/rocket-ui";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ListBrowser, { getListBrowserStore, CollectionType } from "@ts-private/list-browser";
import PartnerSynchronizationListItem from "./PartnerSynchronizationListItem";
import { PARTNER_SYNCHRONIZATION_QUEUE_QUERY, PARTNER_SYNCHRONIZATION_STATUS_LIST_QUERY } from "../queries";
import { PARTNER_SYNCHRONIZATION_INCOMPLETE_STATUS } from "../constants";

import { useApolloFetching } from "@ts-private/list-browser-apollo-extensions";
import { useListBrowserFunctions } from "hooks/useListBrowserFunctions";
import { useTranslation } from "react-i18next";

const partnerSynchronizationListStore = getListBrowserStore({
  name: "partner-synchronization-browser",
  withQueryFilters: false,
  filterDefinitions: [
    {
      name: "partnerName",
      caption: "PartnerSynchronization.Filters.PartnerName",
      type: "text"
    },
    {
      name: "uniqueId",
      caption: "PartnerSynchronization.Filters.UniqueId",
      type: "text"
    },
    {
      name: "status",
      caption: "PartnerSynchronization.Filters.Status",
      initialValue: PARTNER_SYNCHRONIZATION_INCOMPLETE_STATUS,
      type: "select"
    }
  ],
  orderByFields: [
    {
      caption: "PartnerSynchronization.Filters.PartnerName",
      value: "PartnerName"
    }
  ],
  pager: {
    orderBy: "PartnerName",
    direction: "asc"
  }
});

const partnerSynchronizationListFetchingOptions = {
  queryOptions: {
    query: PARTNER_SYNCHRONIZATION_QUEUE_QUERY,
    name: "partnerSynchronizationQueue",
    fetchPolicy: "network-only"
  },
  collectionsOptions: [
    {
      queryOptions: { query: PARTNER_SYNCHRONIZATION_STATUS_LIST_QUERY },
      name: "partnerSynchronizationStatusList",
      identifier: "status",
      collectionType: CollectionType.Filter,
      valueKey: "name",
      labelKey: "name"
    }
  ]
};

const PartnerSynchronizationListBrowser = () => {
  const { t } = useTranslation();
  useApolloFetching(partnerSynchronizationListStore, partnerSynchronizationListFetchingOptions);
  const { textResolver } = useListBrowserFunctions();

  return (
    <CollapseCard
      icon={PeopleAltIcon}
      iconColor="primary"
      title={t("PartnerSynchronization.Title")}
      toggleOnHeaderClick
    >
      <ListBrowser
        store={partnerSynchronizationListStore}
        ItemComponent={PartnerSynchronizationListItem}
        textResolver={textResolver}
      />
    </CollapseCard>
  );
};

export default PartnerSynchronizationListBrowser;
